
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import vuedraggable from 'vuedraggable'
import Sortable from 'sortablejs'
  @Component({
    components: { vuedraggable}
  })
  

export default class ListDetail extends Vue {
    @Prop() dialogListDetail: boolean
    @Prop() title: string
    @Prop() header: any
    @Prop() tableData: any
    @Prop() listDetailId: string
    @Prop() listDetailType: string  // theme points

    oldList: number[] = []
    newList: number[] = []
    sortable: Sortable | null = null
    list: any = []


    @Watch('dialogListDetail')
    getDialog(newVal, oldVal) {
      if (newVal) {
        this.list = this.tableData
        this.oldList = this.list.map((v) => v.id)
        this.newList = this.oldList.slice()
        this.$nextTick(() => {
          this.setSort()
        })
      }
    }

    setSort() {
    const el = (this.$refs.draggableTable as Vue).$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0] as HTMLElement
    this.sortable = Sortable.create(el, {
      ghostClass: 'sortable-ghost', // Class name for the drop placeholder
      onEnd: evt => {
        if (typeof (evt.oldIndex) !== 'undefined' && typeof (evt.newIndex) !== 'undefined') {
          const targetRow = this.list.splice(evt.oldIndex, 1)[0]
          this.list.splice(evt.newIndex, 0, targetRow)
          
          // for show the changes, you can delete in you code
          const tempIndex = this.newList.splice(evt.oldIndex, 1)[0]
          this.newList.splice(evt.newIndex, 0, tempIndex)
        }
      }
    })
  }

    async eduupdateEssentialSort() {
      const data = {
        subject_id: this.listDetailId,
        essential_list: this.newList
      }
      const res: any = await CourseModule.eduupdateEssentialSort(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        this.$emit('close', {type: false, data: []})
      } else {
        this.$message.error('修改失败')
      }   
    }

    async eduupdateSubjectSort() {
      const data = {
        packet_id: this.listDetailId,
        subject_list: this.newList
      }
      const res: any = await CourseModule.eduupdateSubjectSort(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        this.$emit('close', {type: false, data: []})
      } else {
        this.$message.error('修改失败')
      }
    }
    close() {
      this.$emit('close', {type: false, data: []})
    }
    go() {
      if(this.listDetailType === 'theme') {
        this.eduupdateSubjectSort()
      } else if (this.listDetailType === 'points') {
        this.eduupdateEssentialSort()
      }
    }

    mounted() {

    }
}
